(function ($) {
    $.nette.ext('focus', {
        success(payload) {
            if (payload.hasOwnProperty('focus') && payload.focus && payload.hasOwnProperty('snippets')) {
                const elementToFocus = document.getElementById(payload.focus);
                if (elementToFocus) {
                    elementToFocus.scrollIntoView();
                    return;
                }
                for (const i in payload.snippets) {
                    document.getElementById(i).scrollIntoView();
                    break; // only the first should get focus
                }
            }
        },
    });
}(jQuery));
